import { getEnvironment } from "./getEnvironment";
import { getPartnerSlug } from "./getPartnerSlug";

const domainData = getPartnerSlug(getEnvironment());
const partner = domainData.partner;

export const isPartnerWithoutProducts =
  import.meta.env.VITE_APP_PUBLIC_DIRECT_PARTNERS_WITHOUT_PRODUCTS.split(
    ","
  ).includes(partner);

export const isPartnerWithDirectPolicyDownload =
  import.meta.env.VITE_APP_PUBLIC_DIRECT_POLICY_DOWNLOAD_PARTNERS.split(
    ","
  ).includes(partner);
